import { Navigate, Outlet } from 'react-router-dom'
import { usePortalAuthStore } from '@hooks/usePortalAuthStore'

export function PortalProtectedRoute() {
  const { isAuthenticated } = usePortalAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />
  }

  return <Outlet />
}
